import { Map as IMap } from 'immutable';

export const selectModalVisibility = (state) => state.loginReducer.get('modalVisible', false);
export const selectAnimationStatus = (state) => state.loginReducer.get('animationIsPaused', true);
export const selectNextRouteParams = (state) => state.loginReducer.get('nextRouteParams', IMap());
export const selectNextRoute = (state) => state.loginReducer.get('nextRoute', '');